<template>
  <div id="select-month-filed" class="aisea-text-16-400-black">
    <v-select
      name="target_year_month"
      placeholder="年月を選択"
      :value="selectedYearMonth"
      :clearable="false"
      :options="yearMonthList"
      label="label"
      :disabled="yearMonthList.length === 0"
      @input="handleChange"
      style="min-width: 133px"
    >
      <template v-slot:no-options>-</template>
    </v-select>
  </div>
</template>


<script>
import vSelect from "vue-select";

export default {
  name: "SelectMonthField",
  mixins: [],
  components: {
    vSelect,
  },
  props: {
    selectedYearMonth: { Type: Object, default: () => null },
    yearMonthList: { Type: Array, default: [] },
    changeSelectedYearMonth: { Type: Function, default: () => {} },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    handleChange(nextYearMonth) {
      this.changeSelectedYearMonth(nextYearMonth);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#select-month-filed {
  display: flex;
  --vs-dropdown-min-width: 133px;
  .vs__dropdown-menu {
    max-height: 200px;
  }
}
</style>
